import { useState, useEffect, useRef } from "react";

const useEditTimeTracker = (idleTimeout = 300000) => {
    const [isEditing, setIsEditing] = useState(false);
    const [timeSpent, setTimeSpent] = useState(0);
    const lastActivityTime = useRef(Date.now());
    const intervalRef = useRef(null);

    useEffect(() => {
        const checkIdleAndTrackTime = () => {
            const now = Date.now();
            if (isEditing && now - lastActivityTime.current < idleTimeout) {
                setTimeSpent((prevTime) => prevTime + 1);
            } else {
                setIsEditing(false);
            }
        };

        if (isEditing) {
            intervalRef.current = setInterval(checkIdleAndTrackTime, 1000);
        } else {
            clearInterval(intervalRef.current);
        }

        return () => clearInterval(intervalRef.current);
    }, [isEditing, idleTimeout]);

    const startEditing = () => {
        setIsEditing(true);
        lastActivityTime.current = Date.now();
    };

    const recordActivity = () => {
        lastActivityTime.current = Date.now();
        if (!isEditing) {
            setIsEditing(true);
        }
    };

    const getAndResetTimeSpent = () => {
        const time = timeSpent;
        setTimeSpent(0);
        return time;
    };

    return { startEditing, recordActivity, getAndResetTimeSpent };
};

export default useEditTimeTracker;
